import pptxgen from 'pptxgenjs';

import { ControlSlideData, TextBlock } from '../../../Types/dealGPT';

export const generateControlSlide = (
  pres: pptxgen,
  scope: string,
  data: ControlSlideData,
  slideNumber = 1
) => {
  const slide = pres.addSlide({ masterName: 'MASTER_SLIDE' });

  // Constants
  const bulletFontSize = 7;
  const baseY = 1.65;
  const baseX = 3.2;
  const indentStep = 0.25;
  const baseCharsPerLine = 145;
  const charsReducePerIndent = 5;

  // Header
  slide.addText(`SUPPORTING DETAIL: ${scope.toUpperCase()} CONTROLS`, {
    x: 0.1,
    y: 0.2,
    w: '90%',
    h: 0.3,
    fontSize: 8,
    color: '50658E',
    fontFace: 'Arial',
    bold: true,
  });

  slide.addText(data.title || 'Untitled Slide', {
    x: 0.1,
    y: 0.52,
    w: '90%',
    h: 0.5,
    fontSize: 16,
    color: '070154',
    fontFace: 'Arial',
    bold: true,
  });

  slide.addShape('rect', {
    x: 0.2,
    y: 1.25,
    w: 2.6,
    h: 0.3,
    fill: { color: '070154' },
    line: { color: '070154' },
  });

  slide.addText('IMPACT', {
    x: 0.2,
    y: 1.25,
    w: 2.6,
    h: 0.3,
    fontSize: 10,
    color: 'FFFFFF',
    fontFace: 'Arial',
    bold: true,
    align: 'center',
    valign: 'middle',
  });

  // Impact Areas
  const totalHeight = 4.95 - baseY;
  const areaCount = data.areas.length;
  const areaBlockHeight = areaCount > 0 ? totalHeight / areaCount : 0.4;
  let areaY = baseY;

  for (const area of data.areas) {
    const textHeight = 0.3;
    const textOffsetY = (areaBlockHeight - textHeight) / 2;

    slide.addText(area.area, {
      x: 0.2,
      y: areaY + textOffsetY,
      w: 1.5,
      h: textHeight,
      fontSize: 7,
      color: '05013F',
      valign: 'middle',
      align: 'left',
      fontFace: 'Arial',
    });

    slide.addShape('ellipse', {
      x: 2.3,
      y: areaY + (areaBlockHeight - 0.16) / 2,
      w: 0.16,
      h: 0.16,
      fill: { color: area.impact },
      line: { color: area.impact },
    });

    if (areaY !== baseY) {
      slide.addShape('line', {
        x: 0.2,
        y: areaY,
        w: 2.6,
        h: 0,
        line: { color: 'E6E6E6', width: 1 },
      });
    }

    areaY += areaBlockHeight;
  }

  // Topics
  let currentY = 1.27;

  (data.topics as TextBlock[]).forEach(({ textParts, indentLevel }, index) => {
    // Determine if the text is a bullet point
    const isBullet = textParts[0].options?.bullet || false;

    // Apply consistent spacing based on element type
    if (index > 0) {
      const extraSpacing = isBullet ? 0.04 : 0.09;
      currentY += extraSpacing;
    }

    slide.addText(textParts, {
      x: baseX + (indentLevel - 1) * indentStep,
      y: currentY,
      w: 6.65,
      fontSize: bulletFontSize,
      color: '05013F',
      fontFace: 'Arial',
      lineSpacing: 10,
      valign: 'top',
    });

    // Calculate total text length and determine height needed
    const totalText = textParts.map((part) => part.text).join('');
    const charsPerLine = baseCharsPerLine - indentLevel * charsReducePerIndent;
    const effectiveCharsPerLine = isBullet ? charsPerLine - 10 : charsPerLine;

    // Calculate how many lines this text will require
    const linesNeeded = Math.ceil(totalText.length / Math.max(1, effectiveCharsPerLine));

    const heightPerLine = 0.2;
    const baseHeight = isBullet ? 0.09 : 0.1;

    let heightNeeded = 0;
    if (isBullet) {
      heightNeeded = baseHeight;
      if (linesNeeded > 1) {
        heightNeeded += (linesNeeded - 1) * (heightPerLine * 0.8);
      }
    } else {
      heightNeeded = baseHeight + (linesNeeded > 1 ? (linesNeeded - 1) * heightPerLine : 0);
    }

    currentY += heightNeeded;
  });

  // Slide Number
  slide.addText(slideNumber.toString(), {
    x: 9.0,
    y: 4.85,
    w: 1.0,
    h: 0.8,
    align: 'right',
    valign: 'middle',
    fontSize: 7.5,
    color: '484481',
    fontFace: 'Arial',
    bold: false,
  });
};
